import { AvatarProps } from '@radix-ui/react-avatar';

import { Icons } from '@/components/icons';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { UserTable } from '@/server/db/schema/user';

interface UserAvatarProps extends AvatarProps {
  user: Pick<UserTable, 'image' | 'name'>;
}

export function UserAvatar({ user, ...props }: UserAvatarProps) {
  return (
    <Avatar {...props}>
{user.image ? (
        <>
          <AvatarImage alt="Picture" src={user.image} />
          <AvatarFallback>
            {user.name ? (
              `${user.name.split(" ")?.[0]?.[0] ?? ""}${user.name.split(" ")?.at(-1)?.[0] ?? ""}`
            ) : (
              <>
                <span className="sr-only">{user.name}</span>
                <Icons.user className="h-4 w-4" />
              </>
            )}
          </AvatarFallback>
        </>
      ) : (
        <AvatarFallback>
          <span className="sr-only">{user.name}</span>
          <Icons.user className="h-4 w-4" />
        </AvatarFallback>
      )}
    </Avatar>
  );
}
